import { useState } from "react";

import { Input } from "@/components/ui/input";

/** Espejo del tope del servidor (`RotularLaFotoRequest`). */
const MAXIMO_DE_LA_LEYENDA = 200;

interface CampoDeLeyendaProps {
  /** La leyenda guardada, o `null` si la foto no tiene. */
  valor: string | null;
  /** El nombre accesible: "Leyenda de la fotografía 31". */
  etiqueta: string;
  placeholder?: string;
  disabled?: boolean;
  /** Se llama con el texto ya recortado, o `null` para vaciar. Solo si cambió. */
  onGuardar: (leyenda: string | null) => void;
}

/**
 * La leyenda libre de UNA foto: se guarda al salir del campo o con Enter, y
 * solo si cambió.
 *
 * NO ES PARTE DEL FORMULARIO DE LA PESTAÑA: igual que una imagen, se escribe en
 * el servidor en el acto, así que tampoco cuenta como «cambio sin guardar».
 * Un texto en blanco manda `null` y la foto vuelve a su pie automático.
 */
export function CampoDeLeyenda({
  valor,
  etiqueta,
  placeholder = "Leyenda (opcional)",
  disabled,
  onGuardar,
}: CampoDeLeyendaProps) {
  const [texto, setTexto] = useState(valor ?? "");

  function confirmar() {
    const limpio = texto.trim();

    if (limpio === (valor ?? "")) return;

    onGuardar(limpio === "" ? null : limpio);
  }

  return (
    <Input
      aria-label={etiqueta}
      value={texto}
      maxLength={MAXIMO_DE_LA_LEYENDA}
      placeholder={placeholder}
      disabled={disabled}
      className="h-7 text-xs"
      onChange={(e) => setTexto(e.target.value)}
      onBlur={confirmar}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          confirmar();
        }
      }}
    />
  );
}
